@if(ApiUser.HatVolleBerechtigung)
{
<div class="form-floating  mb-3" style="width:100%">
  <input id="GrundSelect" style="width:100%" class="form-control" [ngModel]="selection" (ngModelChange)="selectionChange.emit($event)"
         [ngbTypeahead]="Items"
         [inputFormatter]="formatter"
         [resultFormatter]="formatter"
         [selectOnExact]="true" />

  <label for="GrundSelect">Kooperationspartner</label>
</div>
}
@else
{
<div class="form-floating mb-3">
  <input type="text" class="form-control" id="Kooperationspartner" [ngModel]="selection?.name" readonly disabled>
  <label for="Kooperationspartner">Kooperationspartner</label>
</div>
}
